/**
 * Permission codes the Governance Registers screens declare an interest in.
 *
 * They are the dot-strings `server/internal/foundation/permissions.go` registers
 * with the RBAC catalogue (CLAUDE.md §6) and that arrive on `/auth/me`.
 *
 * - Mastership register (FND-FR-086): which system masters each data domain.
 * - Dependency posture register (FND-FR-089): module-to-module dependencies and criticality.
 * - Classification register (FND-FR-090): sensitive data classification and handling requirements.
 *
 * All three are read-only governance artifacts in this packet.
 */

export const GOVERNANCE_PERMISSIONS = {
  mastershipRead: 'foundation.mastership.read',
  dependencyPostureRead: 'foundation.dependency_posture.read',
  classificationRead: 'foundation.classification.read',
} as const

export type GovernancePermission = (typeof GOVERNANCE_PERMISSIONS)[keyof typeof GOVERNANCE_PERMISSIONS]
